<template>
	<section
		class="page_header"
		:style="{'--progress': 0, '--gradient': 'url(' + gradientBackground + ')'}"
	>
		<div class="container">
			<div
				class='left'
				:class="{'no-desc': !description}"
			>
				<h3
					:data-highlightword="getWordsInFirstRow(title)"
					v-html="title"
				></h3>
			</div>
			<div
				class='right'
				v-if='description'
			>
				<div
					class="description"
					v-html="description"
				></div>
			</div>

			<scroll-button
				target_selector=".page_header"
				:scroll_to_bottom="true"
			></scroll-button>

		</div>

	</section>
</template>

<script>
import ScrollButton from './ScrollButton.vue';
import GradientBackground from '../../images/Duco_Gradient.jpg';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			scrollOpacity: 1,
			gradientBackground: GradientBackground,
		};
	},

	props: {
		title: {},
		description: {},
		call_to_action: {},
		cta_theme_colour: {},
	},

	computed: {
		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		calculateOpacity() {
			return () => {
				const element = document.querySelector('.scroll-element');
				if (!element) return;

				const elementRect = element.getBoundingClientRect();
				const viewportHeight = window.innerHeight;

				// Calculate distance of element from top of viewport
				const distanceFromTop = Math.max(0, elementRect.top);
				// Calculate maximum distance the element can travel
				const maxDistance = viewportHeight + elementRect.height;

				// Calculate opacity based on scroll position
				this.scrollOpacity = 1 - distanceFromTop / maxDistance;
			};
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: {
		ScrollButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		window.addEventListener('scroll', this.calculateOpacity);
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.calculateOpacity);
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.page_header {
	background: var(--very-light-grey);
	position: relative;

	&.gradient {
		background: var(--gradient);
		background-repeat: no-repeat;
		background-size: cover;

		.left {
			h3 {
				color: var(--white) !important;
			}
		}

		.right {
			.description {
				color: var(--white) !important;
			}
		}
	}

	.container {
		padding-top: 75px;
		padding-bottom: 75px;
		position: relative;

		@media (max-width: $mobile-xl) {
			padding-top: 50px;
			padding-bottom: 50px;
			row-gap: 24px;
		}

		.left {
			grid-column: span 4;

			&.no-desc {
				grid-column: span 12;
			}

			h3 {
				color: var(--grey);
				text-transform: capitalize;
				font-weight: 300;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		}

		.right {
			grid-column: 5 / span 7;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			.description {
				color: var(--grey);
				font-size: 24px;
				line-height: 30px;
				font-weight: 300;

				&:first-of-type {
					margin-top: 0;
				}

				&:last-of-type {
					margin-bottom: 0;
				}

				a {
					font-size: 24px;
					line-height: 30px;
					font-weight: 300;
					color: var(--duco-blue);
					text-decoration: none;

					&::after {
						content: '\2192';
						margin-left: 5px;
					}
				}

				&::v-deep {
					p {
						font-size: 24px;
						line-height: 30px;
						font-weight: 300;
						color: var(--grey);

						&:first-of-type {
							margin-top: 0;
						}

						&:last-of-type {
							margin-bottom: 0;
						}

						a {
							font-size: 24px;
							line-height: 30px;
							font-weight: 300;
							color: var(--duco-blue);
							text-decoration: none;

							&::after {
								content: '\2192';
								margin-left: 5px;
							}
						}
					}
				}

				a {
					font-size: 24px;
					line-height: 30px;
					font-weight: 300;
					color: var(--duco-blue);
				}
			}

			.site_button {
				margin-top: 30px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PageHeader.vue